<mat-card class="card-web" appearance="outlined">
    <div class="card-location-image-container-web">
        <img class="card-location-image-web" src="{{photo}}">
    </div>
    <div class="card-location-body-web"> 
      <mat-card-content class="card-location-content-web">
      <div class="card-location-content-container-web">
            <mat-card-title class="card-location-title-web">{{name}}</mat-card-title>
            <div *ngIf="isOpen==true">
                <div class="card-location-wait-time-web" *ngIf="waitTime!=null">
                    <div class="card-location-as-soon-as-web">
                        {{soonAsText}}
                    </div>
                    <div class="card-location-availability-web">
                        {{waitTimeStr}}
                    </div>
                </div>
            </div>
            <div *ngIf="isOpen!=true" class="card-location-wait-time-web">
                <div class="card-location-availability-web">
                    {{openTomorrow}}
                </div>
            </div>
        </div>
        </mat-card-content>
        <mat-card-actions class="card-location-actions-web">
            <div *ngIf="distance != null" class="card-provider-detail-bottom-left-web">
                <svg width="9" height="8.86" viewBox="0 0 9 8.86" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.85468 0L5.21832 9.12723L3.99545 5.13755L0.0221554 4.05578L8.85468 0Z" fill="#959595"/>
                </svg>
                {{distance}} {{milesAwayText}}
            </div>
            <div *ngIf="distance == null" class="card-provider-detail-bottom-left-web"></div>
            <div *ngIf="isOpen==true">
                <div *ngIf="nextAvailability!=null">
                    <button mat-button class="action-button-primary" style="width: 102px; height: 39px;" (click)="reserveNow()">{{reserveText}}</button>
                </div>
                <div *ngIf="nextAvailability==null">
                    <button mat-button class="action-button-primary" style="min-width: 102px; min-height: 39px;" (click)="walkinNow()">{{walkinText}}</button>
                </div>
            </div>
            <div *ngIf="isOpen!=true">
                <button mat-button class="action-button-primary" style="min-width: 120px; min-height: 39px; font-size: 13px;" (click)="vucNow()">{{vucText}}</button>
            </div>
        </mat-card-actions>
    </div>
</mat-card>
